/**
 * CCA transport vs business error boundaries + section readiness.
 * VISTOERA_CCA_TENANT_FALSE_NETWORK_ERROR_AND_EXISTING_PC4_ANALYSIS_VISIBILITY_RECOVERY_V1
 */
import type { ReferenceContentDetail, SaasApiError } from '../api'
import { isMediaLayerVisible } from './competitiveContentRealData'

export function isTransportSaasError(err: unknown): boolean {
  const e = err as SaasApiError | undefined
  if (!e) return true
  // Axios interceptor sets status only when a response existed.
  if (typeof e.status === 'number') return false
  return true
}

export type CcaSectionReadiness = {
  summaryReady: boolean
  transcriptReady: boolean
  shotTimelineReady: boolean
  visualReady: boolean
  aiInsightsReady: boolean
  baseAnalysisPresent: boolean
}

export function resolveCcaSectionReadiness(detail: ReferenceContentDetail | null): CcaSectionReadiness {
  if (!detail) {
    return {
      summaryReady: false,
      transcriptReady: false,
      shotTimelineReady: false,
      visualReady: false,
      aiInsightsReady: false,
      baseAnalysisPresent: false,
    }
  }
  const mediaVisible = isMediaLayerVisible(detail.media_analysis)
  const transcriptReady = (detail.transcript?.length || 0) > 0
  const shotTimelineReady = (detail.shots?.length || 0) > 0
  const visualReady =
    mediaVisible ||
    shotTimelineReady ||
    Boolean(detail.media_analysis?.motion_analysis) ||
    (detail.image_pages?.length || 0) > 0
  const aiInsightsReady = detail.analysis?.status === 'succeeded'
  const baseAnalysisPresent = transcriptReady || shotTimelineReady || mediaVisible
  return {
    summaryReady: baseAnalysisPresent || detail.status !== 'pending',
    transcriptReady,
    shotTimelineReady,
    visualReady,
    aiInsightsReady,
    baseAnalysisPresent,
  }
}

/** Prefer existing PC4 rows over media-status gates. */
export function shouldRenderExistingTranscript(detail: ReferenceContentDetail): boolean {
  return (detail.transcript?.length || 0) > 0
}

export function shouldRenderExistingShots(detail: ReferenceContentDetail): boolean {
  return (detail.shots?.length || 0) > 0
}
